export const environment = {
  production: false,
  envType: 'DEVELOPMENT',
  isFullOnline: true,
  caisseApiUrl: 'https://devgestion.quiditmiam.fr/api',
  title: 'Caisse Collective - Développement',
  buildDate: "2026-09-17T14:26:14",
  lastPipeline: "6564",
  version: "0.0.0",
  sentryDsn: '',
};
